const charactersNotAllowedInTableAndColumnName = [
  '!', '"', '#', '$', '%', '&', '\'', '(', ')', '*', '+', ',', '.', '/', '@', '^', '=', ';', ':', '{', '}', '[', ']'];

export default charactersNotAllowedInTableAndColumnName;